import React from 'react';
import { FeedTypeFilter } from 'types/interfaces/followingFeed';

export type FilterTabKey = 'ALL' | FeedTypeFilter;

interface NewsfeedFilterTabsProps {
  active: FilterTabKey;
  onChange: (key: FilterTabKey) => void;
}

const TABS: { key: FilterTabKey; label: string }[] = [
  { key: 'ALL', label: 'All' },
  { key: 'WANT_ADDED', label: 'New Wants' },
  { key: 'TRADES', label: 'Trades' },
  { key: 'MILESTONE_EARNED', label: 'Milestones' },
];

export const NewsfeedFilterTabs: React.FC<NewsfeedFilterTabsProps> = ({
  active,
  onChange,
}) => {
  return (
    <div className="newsfeed-filter-tabs" role="tablist">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          role="tab"
          aria-selected={active === tab.key}
          className={`newsfeed-filter-tab ${active === tab.key ? 'newsfeed-filter-tab--active' : ''}`}
          onClick={() => onChange(tab.key)}
          type="button"
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default NewsfeedFilterTabs;
